/**
 * One width for the builder's left-hand column, and the controls that line up with it.
 *
 * THREE PLACES HAD THREE NUMBERS -- "Report on" at 320, "Saved reports" at 260 and the FIELDS
 * column at 250 -- which read as three slightly different things rather than as one column, and
 * nothing in the code said they were meant to agree. A constant is the only thing that keeps them
 * in step: the next person to widen one of them will see the other two move with it, which is the
 * behaviour the layout always implied and never had.
 *
 * IT LIVES IN ITS OWN MODULE because the three users are in three files -- a page, a bar and the
 * shelves -- and none of them is the natural home for a constant the others import.
 */
export const BUILDER_COLUMN = 320;


/**
 * The column beside it: "One row per", and the "Name" field directly under it.
 *
 * THE SAME REASON AS BUILDER_COLUMN -- they sit one above the other and are meant to read as one
 * column, so they are one number rather than two that happen to match today.
 */
export const BUILDER_SECOND_COLUMN = 280;
